module.exports = __webpack_public_path__ + "img/slide2.09383ac6.jpg";